import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { PatientAppointmentItem } from "./PatientAppointmentItem";

class PatientAppointmentListItem implements ITableDataSourceItem<PatientAppointmentItem> {
    constructor(model: PatientAppointmentItem) {
        this.Model = model;
    }

    public Model: PatientAppointmentItem;
    public Name: string;
}

export { PatientAppointmentListItem };
